(function () {
  /* JetRunners size system toggle + size guide modal.
     Works with Horizon-style variant picker:
     label.variant-option__button-label > input + span.variant-option__button-label__text
     Toggle markup comes from the product template block:
     div.size-system-toggle[data-vendor] > button.sst-btn[data-sys=USM|USW|EU|UK] */

  var DATA = {
    nike: { m: [["38.5","6","5.5"],["39","6.5","6"],["40","7","6"],["40.5","7.5","6.5"],["41","8","7"],["42","8.5","7.5"],["42.5","9","8"],["43","9.5","8.5"],["44","10","9"],["44.5","10.5","9.5"],["45","11","10"],["45.5","11.5","10.5"],["46","12","11"],["47","12.5","11.5"],["47.5","13","12"],["48.5","14","13"]],
            w: [["35.5","5","2.5"],["36","5.5","3"],["36.5","6","3.5"],["37.5","6.5","4"],["38","7","4.5"],["38.5","7.5","5"],["39","8","5.5"],["40","8.5","6"],["40.5","9","6.5"],["41","9.5","7"],["42","10","7.5"],["42.5","10.5","8"],["43","11","8.5"],["44","12","9.5"]] },
    adidas: { m: [["38⅔","6","5.5"],["39⅓","6.5","6"],["40","7","6.5"],["40⅔","7.5","7"],["41⅓","8","7.5"],["42","8.5","8"],["42⅔","9","8.5"],["43⅓","9.5","9"],["44","10","9.5"],["44⅔","10.5","10"],["45⅓","11","10.5"],["46","11.5","11"],["46⅔","12","11.5"],["47⅓","12.5","12"],["48","13","12.5"],["49⅓","14","13.5"]],
              w: [["36","5","3.5"],["36⅔","5.5","4"],["37⅓","6","4.5"],["38","6.5","5"],["38⅔","7","5.5"],["39⅓","7.5","6"],["40","8","6.5"],["40⅔","8.5","7"],["41⅓","9","7.5"],["42","9.5","8"],["42⅔","10","8.5"],["43⅓","10.5","9"],["44","11","9.5"]] },
    asics: { m: [["39","6","5"],["39.5","6.5","5.5"],["40","7","6"],["40.5","7.5","6.5"],["41.5","8","7"],["42","8.5","7.5"],["42.5","9","8"],["43.5","9.5","8.5"],["44","10","9"],["44.5","10.5","9.5"],["45","11","10"],["46","11.5","10.5"],["46.5","12","11"],["47","12.5","11.5"],["48","13","12"],["49","14","13"]],
             w: [["35.5","5","3.5"],["36","5.5","4"],["37","6","4.5"],["37.5","6.5","5"],["38","7","5.5"],["39","7.5","6"],["39.5","8","6.5"],["40","8.5","7"],["40.5","9","7.5"],["41.5","9.5","8"],["42","10","8.5"],["42.5","10.5","9"],["43.5","11","9.5"]] },
    saucony: { m: [["38.5","6","5"],["39","6.5","5.5"],["40","7","6"],["40.5","7.5","6.5"],["41","8","7"],["42","8.5","7.5"],["42.5","9","8"],["43","9.5","8.5"],["44","10","9"],["44.5","10.5","9.5"],["45","11","10"],["45.5","11.5","10.5"],["46","12","11"],["47","12.5","11.5"],["47.5","13","12"],["49","14","13"]],
               w: [["36","5","3"],["36.5","5.5","3.5"],["37.5","6","4"],["38","6.5","4.5"],["38.5","7","5"],["39","7.5","5.5"],["40","8","6"],["40.5","8.5","6.5"],["41","9","7"],["42","9.5","7.5"],["42.5","10","8"],["43","10.5","8.5"],["44","11","9"]] },
    newbalance: { m: [["38.5","6","5.5"],["39","6.5","6"],["40","7","6.5"],["40.5","7.5","7"],["41.5","8","7.5"],["42","8.5","8"],["42.5","9","8.5"],["43","9.5","9"],["44","10","9.5"],["44.5","10.5","10"],["45","11","10.5"],["45.5","11.5","11"],["46.5","12","11.5"],["47.5","13","12.5"],["49","14","13.5"]],
                  w: [["35.5","5","3"],["36","5.5","3.5"],["36.5","6","4"],["37.5","6.5","4.5"],["38","7","5"],["38.5","7.5","5.5"],["39","8","6"],["40","8.5","6.5"],["40.5","9","7"],["41","9.5","7.5"],["42","10","8"],["42.5","10.5","8.5"],["43","11","9"]] },
    hoka: { m: [["38⅔","6","5.5"],["39⅓","6.5","6"],["40","7","6.5"],["40⅔","7.5","7"],["41⅓","8","7.5"],["42⅔","9","8.5"],["43⅓","9.5","9"],["44","10","9.5"],["44⅔","10.5","10"],["45⅓","11","10.5"],["46","11.5","11"],["46⅔","12","11.5"],["47⅓","12.5","12"],["48","13","12.5"],["49⅓","14","13.5"]],
            w: [["36","5","3.5"],["36⅔","5.5","4"],["37⅓","6","4.5"],["38","6.5","5"],["38⅔","7","5.5"],["39⅓","7.5","6"],["40","8","6.5"],["40⅔","8.5","7"],["41⅓","9","7.5"],["42","9.5","8"],["42⅔","10","8.5"],["43⅓","10.5","9"],["44","11","9.5"]] },
    puma: { m: [["39","7","6"],["40","7.5","6.5"],["40.5","8","7"],["41","8.5","7.5"],["42","9","8"],["42.5","9.5","8.5"],["43","10","9"],["44","10.5","9.5"],["44.5","11","10"],["45","11.5","10.5"],["46","12","11"],["46.5","12.5","11.5"],["47","13","12"],["48","13.5","12.5"],["48.5","14","13"]],
            w: [["35.5","5","2.5"],["36","5.5","3"],["37","6","3.5"],["37.5","6.5","4"],["38","7","4.5"],["38.5","7.5","5"],["39","8","5.5"],["40","8.5","6"],["40.5","9","6.5"],["41","9.5","7"],["42","10","7.5"],["42.5","10.5","8"],["43","11","8.5"]] },
    salomon: { m: [["40","7","6.5"],["40⅔","7.5","7"],["41⅓","8","7.5"],["42","8.5","8"],["42⅔","9","8.5"],["43⅓","9.5","9"],["44","10","9.5"],["44⅔","10.5","10"],["45⅓","11","10.5"],["46","11.5","11"],["46⅔","12","11.5"],["47⅓","12.5","12"],["48","13","12.5"],["48⅔","13.5","13"],["49⅓","14","13.5"]],
               w: [["36","5.5","3.5"],["36⅔","6","4"],["37⅓","6.5","4.5"],["38","7","5"],["38⅔","7.5","5.5"],["39⅓","8","6"],["40","8.5","6.5"],["40⅔","9","7"],["41⅓","9.5","7.5"],["42","10","8"],["42⅔","10.5","8.5"],["43⅓","11","9"],["44","11.5","9.5"]] },
    brooks: { m: [["38.5","6","5"],["39","6.5","5.5"],["40","7","6"],["40.5","7.5","6.5"],["41","8","7"],["42","8.5","7.5"],["42.5","9","8"],["43","9.5","8.5"],["44","10","9"],["44.5","10.5","9.5"],["45","11","10"],["45.5","11.5","10.5"],["46","12","11"],["46.5","12.5","11.5"],["47.5","13","12"],["48.5","14","13"]],
              w: [["35.5","5","3"],["36","5.5","3.5"],["36.5","6","4"],["37.5","6.5","4.5"],["38","7","5"],["38.5","7.5","5"],["39","8","5.5"],["40","8.5","6"],["40.5","9","6.5"],["41","9.5","7"],["42","10","7.5"],["42.5","10.5","8"],["43","11","8.5"],["44","11.5","9"],["44.5","12","9.5"],["45","12.5","10"],["45.5","13","10.5"]] }
  };

  var BRAND_LABELS = { nike:"Nike", adidas:"adidas", asics:"ASICS", saucony:"Saucony", newbalance:"New Balance", hoka:"HOKA", puma:"PUMA", salomon:"Salomon", brooks:"Brooks" };
  var SYS_LABELS = { USM:"US M", USW:"US W", EU:"EU", UK:"UK" };
  var GUIDE_URL = "/pages/size-guide";

  function norm(s){ return String(s||"").toLowerCase().replace(/[^a-z]/g,""); }
  function brandKey(raw){
    var k = norm(raw), keys = Object.keys(DATA);
    for (var i=0;i<keys.length;i++){ if (k.indexOf(keys[i]) > -1) return keys[i]; }
    return null;
  }
  function euNum(s){
    s = String(s).trim();
    var f = 0;
    if (s.indexOf("⅓") > -1) f = 1/3;       /* 1/3 */
    else if (s.indexOf("⅔") > -1) f = 2/3;  /* 2/3 */
    else if (s.indexOf("½") > -1) f = 0.5;  /* 1/2 */
    var n = parseFloat(s.replace(/[⅓⅔½]/g, "").replace(",", "."));
    return isNaN(n) ? null : n + f;
  }
  function num(s){ var n = parseFloat(String(s).replace(",", ".")); return isNaN(n) ? null : n; }
  function half(n){ return Math.round(n * 2) / 2; }
  function fmt(n){ return (n % 1 === 0) ? String(n) : String(n); }

  /* rows: array of [eu, size, uk]; col 1 = target US size, col 2 = UK */
  function buildPoints(rows, col){
    var pts = [];
    for (var i=0;i<rows.length;i++){
      var x = euNum(rows[i][0]), y = num(rows[i][col]);
      if (x !== null && y !== null) pts.push([x, y]);
    }
    pts.sort(function(a,b){ return a[0]-b[0]; });
    return pts;
  }
  function interp(pts, x){
    if (!pts.length) return null;
    for (var i=0;i<pts.length;i++){ if (Math.abs(pts[i][0]-x) < 0.08) return pts[i][1]; }
    if (x <= pts[0][0]){
      if (pts.length < 2) return pts[0][1];
      var a=pts[0], b=pts[1];
      return half(a[1] + (x-a[0]) * (b[1]-a[1]) / (b[0]-a[0]));
    }
    if (x >= pts[pts.length-1][0]){
      if (pts.length < 2) return pts[pts.length-1][1];
      var a2=pts[pts.length-2], b2=pts[pts.length-1];
      return half(b2[1] + (x-b2[0]) * (b2[1]-a2[1]) / (b2[0]-a2[0]));
    }
    for (var j=0;j<pts.length-1;j++){
      var p=pts[j], q=pts[j+1];
      if (x > p[0] && x < q[0]) return half(p[1] + (x-p[0]) * (q[1]-p[1]) / (q[0]-p[0]));
    }
    return null;
  }

  function getToggle(){ return document.querySelector(".size-system-toggle"); }
  function getBrand(){
    var el = getToggle();
    var raw = el ? (el.getAttribute("data-vendor") || "") : "";
    return brandKey(raw);
  }
  function sizeSpans(){ return document.querySelectorAll(".variant-option__button-label .variant-option__button-label__text"); }

  var state = { sys: "EU" };
  try { var saved = window.localStorage.getItem("jr-size-sys"); if (saved && SYS_LABELS[saved]) state.sys = saved; } catch (e) {}

  var CONV = null; /* { USM: pts, USW: pts, UKM: pts, UKW: pts } */
  function buildConv(){
    var b = getBrand();
    if (!b) { CONV = null; return; }
    var d = DATA[b];
    CONV = {
      USM: buildPoints(d.m, 1),
      USW: buildPoints(d.w, 1),
      UK:  buildPoints(d.m, 2).concat([]),
      UKW: buildPoints(d.w, 2)
    };
    if (!CONV.UK.length) CONV.UK = CONV.UKW;
  }

  function convert(euLabel, sys){
    if (sys === "EU" || !CONV) return null;
    var x = euNum(euLabel);
    if (x === null) return null;
    var pts = sys === "USM" ? CONV.USM : sys === "USW" ? CONV.USW : CONV.UK;
    if (sys === "UK" && (!pts || !pts.length)) pts = CONV.UKW;
    var y = interp(pts, x);
    return y === null ? null : fmt(y);
  }

  var applying = false;
  function apply(){
    applying = true;
    var spans = sizeSpans();
    for (var i=0;i<spans.length;i++){
      var sp = spans[i];
      var eu = sp.getAttribute("data-eu");
      if (!eu){ eu = sp.textContent.trim(); sp.setAttribute("data-eu", eu); }
      if (state.sys === "EU"){ if (sp.textContent !== eu) sp.textContent = eu; }
      else {
        var v = convert(eu, state.sys);
        var txt = v === null ? eu : v;
        if (sp.textContent !== txt) sp.textContent = txt;
      }
    }
    applying = false;
  }

  var BTN_BASE = "border:0;padding:5px 12px;cursor:pointer;font:inherit;";
  function setActive(){
    var btns = document.querySelectorAll(".size-system-toggle .sst-btn");
    for (var i=0;i<btns.length;i++){
      var on = btns[i].getAttribute("data-sys") === state.sys;
      btns[i].setAttribute("style", BTN_BASE + (on ? "background:#111;color:#fff;" : "background:transparent;color:#111;"));
      btns[i].setAttribute("aria-pressed", on ? "true" : "false");
    }
  }

  function setSys(sys){
    state.sys = sys;
    try { window.localStorage.setItem("jr-size-sys", sys); } catch (e) {}
    setActive();
    apply();
  }

  /* ---------- Size guide modal ---------- */
  function mergedRows(b){
    var d = DATA[b], map = {};
    function put(rows, key){
      for (var i=0;i<rows.length;i++){
        var euRaw = rows[i][0], x = euNum(euRaw);
        var id = (x === null) ? euRaw : String(Math.round(x*100));
        if (!map[id]) map[id] = { x: x, eu: euRaw, usm: "–", usw: "–", uk: "–" };
        map[id][key] = rows[i][1];
        if (map[id].uk === "–") map[id].uk = rows[i][2];
      }
    }
    put(d.m, "usm");
    put(d.w, "usw");
    var arr = Object.keys(map).map(function(k){ return map[k]; });
    arr.sort(function(a,b2){ return (a.x||0) - (b2.x||0); });
    return arr;
  }
  function buildModal(){
    var b = getBrand();
    if (!b) { window.location.href = GUIDE_URL; return null; }
    var rows = mergedRows(b);
    var wrap = document.createElement("div");
    wrap.className = "sst-modal-overlay";
    wrap.setAttribute("style", "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;");
    var card = document.createElement("div");
    card.setAttribute("style", "background:#fff;color:#111;max-width:520px;width:100%;max-height:82vh;overflow:auto;border-radius:12px;padding:22px 22px 18px;position:relative;box-shadow:0 18px 50px rgba(0,0,0,.28);");
    var close = document.createElement("button");
    close.type = "button";
    close.textContent = "×";
    close.setAttribute("aria-label", "Close");
    close.setAttribute("style", "position:absolute;top:8px;right:12px;border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:#111;");
    var h = document.createElement("h3");
    h.textContent = (BRAND_LABELS[b] || b) + " size chart";
    h.setAttribute("style", "margin:0 36px 12px 0;font-size:20px;");
    var tbl = document.createElement("table");
    tbl.setAttribute("style", "width:100%;border-collapse:collapse;font-size:14px;");
    var thead = document.createElement("thead");
    var trh = document.createElement("tr");
    ["EU","US M","US W","UK"].forEach(function(t){
      var th = document.createElement("th");
      th.textContent = t;
      th.setAttribute("style", "background:#111;color:#fff;padding:7px 8px;text-align:center;");
      trh.appendChild(th);
    });
    thead.appendChild(trh);
    tbl.appendChild(thead);
    var tbody = document.createElement("tbody");
    for (var i=0;i<rows.length;i++){
      var tr = document.createElement("tr");
      [rows[i].eu, rows[i].usm, rows[i].usw, rows[i].uk].forEach(function(t, ci){
        var td = document.createElement("td");
        td.textContent = t;
        td.setAttribute("style", "padding:6px 8px;text-align:center;border-bottom:1px solid #eee;" + (ci === 0 ? "font-weight:600;" : ""));
        tr.appendChild(td);
      });
      if (i % 2) tr.setAttribute("style", "background:#f7f7f7;");
      tbody.appendChild(tr);
    }
    tbl.appendChild(tbody);
    var foot = document.createElement("p");
    foot.setAttribute("style", "margin:14px 0 0;font-size:13px;");
    var a = document.createElement("a");
    a.href = GUIDE_URL;
    a.textContent = "Open the full size guide →";
    a.setAttribute("style", "color:#111;text-decoration:underline;");
    foot.appendChild(a);
    card.appendChild(close);
    card.appendChild(h);
    card.appendChild(tbl);
    card.appendChild(foot);
    wrap.appendChild(card);
    function remove(){
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      document.removeEventListener("keydown", esc);
    }
    function esc(e){ if (e.key === "Escape") remove(); }
    close.addEventListener("click", remove);
    wrap.addEventListener("click", function(e){ if (e.target === wrap) remove(); });
    document.addEventListener("keydown", esc);
    return wrap;
  }
  function openModal(e){
    if (e) e.preventDefault();
    var m = buildModal();
    if (m) document.body.appendChild(m);
  }

  function placeToggle(){
    var tgl = getToggle();
    if (!tgl) return;
    var picker = document.querySelector("variant-picker");
    if (!picker || !picker.parentElement) return;
    var holder = document.querySelector(".sst-holder");
    if (!holder || !holder.isConnected){
      holder = document.createElement("div");
      holder.className = "sst-holder";
      holder.setAttribute("style", "margin:0 0 14px;");
    }
    if (holder.parentElement !== picker.parentElement || holder.nextElementSibling !== picker){
      picker.parentElement.insertBefore(holder, picker);
    }
    if (tgl.parentElement !== holder) holder.appendChild(tgl);
    var link = document.querySelector(".sst-guide-link");
    if (link && link.parentElement !== holder) holder.appendChild(link);
  }

  function ensureGuideLink(){
    var tgl = getToggle();
    if (!tgl || tgl.parentNode.querySelector(".sst-guide-link")) return;
    var a = document.createElement("a");
    a.className = "sst-guide-link";
    a.href = GUIDE_URL;
    a.textContent = "📏 Size guide";
    a.setAttribute("style", "display:inline-block;margin-left:12px;font-size:13px;color:#111;text-decoration:underline;cursor:pointer;vertical-align:middle;");
    a.addEventListener("click", openModal);
    tgl.parentNode.insertBefore(a, tgl.nextSibling);
  }

  /* ---------- wiring ---------- */
  function bind(){
    var tgl = getToggle();
    if (!tgl || tgl.getAttribute("data-sst-bound")) return;
    tgl.setAttribute("data-sst-bound", "1");
    tgl.addEventListener("click", function(e){
      var btn = e.target.closest ? e.target.closest(".sst-btn") : null;
      if (!btn) return;
      e.preventDefault();
      setSys(btn.getAttribute("data-sys") || "EU");
    });
  }

  var t0 = null;
  function refresh(){
    if (applying) return;
    if (t0) clearTimeout(t0);
    t0 = setTimeout(function(){
      buildConv();
      placeToggle();
      bind();
      ensureGuideLink();
      setActive();
      apply();
    }, 60);
  }

  function run(){
    if (!getToggle() && !sizeSpans().length) return;
    buildConv();
    placeToggle();
    if (!CONV){
      var tgl = getToggle();
      if (tgl) tgl.style.display = "none";
      ensureGuideLink();
      return;
    }
    bind();
    ensureGuideLink();
    setActive();
    apply();
    var root = document.querySelector("main") || document.body;
    var mo = new MutationObserver(function(){ refresh(); });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
